import Cookies from 'js-cookie';

import { api } from '../../../utils/api-client';
import { ApiRoutesEnum } from '../../../utils/routes';

export const login = (userName: string, password: string) =>
  api.post<{ token: string }>(ApiRoutesEnum.login, {
    username: userName,
    password,
  });

export const logout = () => {
  Cookies.remove('token');
};
